import { Badge } from '../ui/badge';
import type { MessageClassification, SenderRoleLabel } from './types';

interface MessageTypeBadgeProps {
  classification: MessageClassification;
  size?: 'sm' | 'default';
}

const CLASSIFICATION_STYLES: Record<MessageClassification, { label: string; className: string }> = {
  informational: {
    label: 'Informational',
    className: 'bg-slate-100 text-slate-700 border-slate-200',
  },
  action_required: {
    label: 'Action Required',
    className: 'bg-amber-50 text-amber-700 border-amber-200',
  },
  urgent: {
    label: 'Urgent',
    className: 'bg-rose-50 text-rose-700 border-rose-200',
  },
};

export function MessageTypeBadge({ classification, size = 'default' }: MessageTypeBadgeProps) {
  const style = CLASSIFICATION_STYLES[classification] || CLASSIFICATION_STYLES.informational;
  return (
    <Badge
      variant="outline"
      className={`${style.className} ${size === 'sm' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'} font-medium`}
    >
      {style.label}
    </Badge>
  );
}

interface SenderRoleBadgeProps {
  roleLabel: SenderRoleLabel;
  size?: 'sm' | 'default';
}

const ROLE_STYLES: Record<SenderRoleLabel, string> = {
  Client: 'bg-blue-50 text-blue-700 border-blue-200',
  Consultant: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  EL: 'bg-violet-50 text-violet-700 border-violet-200',
  SA: 'bg-orange-50 text-orange-700 border-orange-200',
  System: 'bg-gray-100 text-gray-500 border-gray-200',
};

export function SenderRoleBadge({ roleLabel, size = 'default' }: SenderRoleBadgeProps) {
  const className = ROLE_STYLES[roleLabel] || ROLE_STYLES.Consultant;
  return (
    <Badge
      variant="outline"
      className={`${className} ${size === 'sm' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'} font-medium`}
    >
      {roleLabel}
    </Badge>
  );
}
